import FileGrid from './FileGrid';
import './FileGrid.scss';

export default FileGrid;
